import { isUserLoggedIn } from '../../utils/authUtils';
import { CrudServiceBase } from '../base/crudServiceBase';
import Endpoint from '../endpoint';
import { download, httpApi } from '../httpService';
import { DocumentsDto } from './dto/documentsDto';
import { DocumentTypeEnum } from './dto/documentTypeEnums';

export class DocumentsService extends CrudServiceBase<DocumentsDto> {
    constructor() {
        super(Endpoint.Document);
        this.internalHttp = httpApi;
    }

    public async create(createDocumentsInput: DocumentsDto) {
        isUserLoggedIn();

        let paramsToPass: any = {clientId: createDocumentsInput.clientId};

        if(createDocumentsInput.documentType === DocumentTypeEnum.BrokerSelectionDeclaration) {
          paramsToPass = {clientId: createDocumentsInput.clientId, insuranceCompanyId: createDocumentsInput.insuranceCompanyId, product: createDocumentsInput.product};
        }
        
        let result = await this.internalHttp.post(this.endpoint.Custom(`Generate${createDocumentsInput.documentType}`), paramsToPass);
        const resultToReturn = !!result.data && result.data.hasOwnProperty('result') ? result.data.result : result.data;

        if(resultToReturn && resultToReturn.attachedFiles && resultToReturn.attachedFiles.length > 0) {
            const url = resultToReturn.attachedFiles[0].fileUrl;
            const name = resultToReturn.attachedFiles[0].originalFileName;

            await download(url, name);
        }

        return resultToReturn;
    }
}

const exportDocumentsService: DocumentsService = new DocumentsService();
export default exportDocumentsService;